import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { RememberService } from '../../../core/services/remember.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-plans-delivery-location',
  templateUrl: './consignment-plans-delivery-location.component.html',
  styleUrls: ['./consignment-plans-delivery-location.component.css']
})
export class ConsignmentPlansDeliveryLocationComponent implements OnInit {
    public itemsListStockLocations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private rememberService: RememberService) {

    }

    private async loadStockLocations() {
        this.itemsListStockLocations = await this.datatask.Post(1718);
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        Promise.all([
            this.rememberService.remember('consignmentplansdelivery.stocklocation_keyno', event?.item?.item_id),
            this.rememberService.remember('consignmentplansdelivery.stocklocation_name', event?.item?.item_name)
        ]).then(() => {
            this.stateService.back();
            Promise.resolve();
        });
    }

    private async init() {
        this.loadStockLocations();
    }

    ngOnInit() {
        this.init();
    }
}
